import React, { FC, ReactNode } from 'react';

import getClassName from 'src/common/utils/getClassName';
import s from './Quote.module.scss';

type QuotePropsType = {
  name?: string;
  children: ReactNode;
  classNameModifier?: string;
};

const Quote: FC<QuotePropsType> = ({
  name,
  children,
  classNameModifier,
}) => (
  <blockquote className={getClassName(s, 'root', classNameModifier)}>
    <p className={s.quote}>
      {children}
    </p>
    {name && `- ${name}`}
  </blockquote>
);
export default Quote;
